import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, TextField, CircularProgress, Alert,
} from '@mui/material';
import { LockReset } from '@mui/icons-material';
import { authApi } from '../services/hrmsApi';
import { useAuth } from '../context/AuthContext';

export default function ForceChangePasswordDialog() {
  const { clearMustChangePassword } = useAuth();

  const [form,   setForm]   = useState({ newPassword: '', confirmNewPassword: '' });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const [error,  setError]  = useState(null);

  const setField = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const validate = () => {
    const errs = {};
    if (!form.newPassword) errs.newPassword = 'Required';
    else if (form.newPassword.length < 6) errs.newPassword = 'Min 6 characters';
    if (form.confirmNewPassword !== form.newPassword) errs.confirmNewPassword = 'Passwords do not match';
    return errs;
  };

  const submit = async () => {
    const errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }

    setSaving(true);
    setError(null);
    try {
      await authApi.forcePasswordChange(form.newPassword);
      clearMustChangePassword();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update password.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      open
      disableEscapeKeyDown
      onClose={() => {}}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, textAlign: 'center' } }}
    >
      <DialogTitle sx={{ pb: 0, pt: 3 }}>
        <Box sx={{
          width: 56, height: 56, borderRadius: '14px', bgcolor: '#E3F2FD',
          display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 1.5,
        }}>
          <LockReset sx={{ fontSize: 30, color: '#1565C0' }} />
        </Box>
        <Typography variant="h6" fontWeight={700}>Set a New Password</Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 1.5 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
          Your password was reset by an administrator. Choose a new password to continue.
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'left' }}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            label="New Password *" type="password" size="small" fullWidth
            value={form.newPassword} onChange={setField('newPassword')}
            error={!!errors.newPassword} helperText={errors.newPassword}
          />
          <TextField
            label="Confirm New Password *" type="password" size="small" fullWidth
            value={form.confirmNewPassword} onChange={setField('confirmNewPassword')}
            error={!!errors.confirmNewPassword} helperText={errors.confirmNewPassword}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 3, pt: 2 }}>
        <Button variant="contained" size="large" onClick={submit} disabled={saving}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : undefined}
          sx={{ px: 5 }}>
          {saving ? 'Updating…' : 'Set Password'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
